
<template>
  <div class="record_box">
    <div class="header">
      <p class="h_title">当前金币</p>
      <p class="h_coins">{{account.gold}}</p>
    </div>
    <div class="sign_box">
      <p class="s_title">连续7天 领惊喜大礼包 <span class="right"
              @click="toPage('/vipActive/coinsDetail')">金币明细 <span class="icon_right"></span></span></p>
      <ul class="flx">
        <li class=""
            v-for="(item,index) in list"
            :key="index"
            :class="{'active':index<account.continuousDay}"
            @click="toLuckDraw(item,index)">
          <span class="sign_icon"
                :class="{'sign_icon4':index<account.continuousDay,'sign_icon2':index==2,'sign_icon3':index==6}"></span><br>
          <span class="num"
                v-if="account.continuousDay>index">{{index+1}}天</span>
          <span class="num"
                v-else>{{index!==2&&index!==6?'+':''}}{{item}}</span>
        </li>
      </ul>
      <p class="s_btn"
         @click="toSign"
         :class="{'btn_Act':account.flag&&!account.canLottery}">{{changeBtnText(btnText)}}</p>
    </div>
    <div class="wait_box"
         v-if="receivableTasks.length>0">
      <p class="c_title">
        待领取金币 <span class="right more"
              @click="toPage('/vipActive/waitCoinsList')">更多<span class="icon_right"></span></span>
      </p>
      <div class="record_item">
        <div class="box"
             v-for="(item,index) in receivableTasks"
             :key="index">
          <div class="look_limit">
            <img class="logo"
                 :src="item.iconUrl" />
            <span class="name">{{item.name}}</span>
            <span class="limit"
                  @click="showCoins(item)">+{{item.price}} <span class="coins"></span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="wait_box"
         v-if="products.length>0">
      <p class="c_title">
        大家都在看 <span class="right more"
              @click="toPage('/vipActive/coinsShop')">更多<span class="icon_right"></span></span>
      </p>
      <div class="look_box">
        <div class="item"
             v-for="(item,index) in products"
             :key="index"
             @click="toPage('/vipActive/couponDetailList',item)">
          <img :src="item.imgSmall"
               alt="">
          <p class="l_name">{{item.name}}</p>
          <p><span class="coins"></span> <span class="red">{{item.price}}金币</span></p>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="task_box"
         v-if="tasksCenter.length>0">
      <p class="c_title">
        任务中心
      </p>
      <div class="record_item">
        <div class="box"
             v-for="(item,index) in tasksCenter"
             :key="index">
          <div class="look_limit"
               @click.stop="showTaskToast(item,0)">
            <img class="logo"
                 :src="item.iconUrl" />
            <p class="name">
              <span>{{item.name}}</span><br>
              <span class="coins"></span><span class="t_coins"> {{item.price}}金币</span>
            </p>
            <span class="limit"
                  :class="{'t_btnAct':item.status}"
                  @click.stop="showTaskToast(item,1)">{{changeStatus(item.status)}}</span>
          </div>
        </div>
      </div>
    </div>
    <MessageInfo :propJson="propJson"
                 @sureClick="sureClick"
                 @secondClick="secondClick" />
    <VueLottie :propJson="coinsPropJson"
               @toHideGif="toHideGif"
               ref="vueLottie" />
  </div>
</template>

<script>
import VueLottie from '../../components/vueLottie';
import MessageInfo from '@/components/messageInfo';
export default {
  props: ['learning'],
  components: {
    MessageInfo,
    VueLottie
  },
  data () {
    return {
      coinsPropJson: {
        isShow: false,
        price: '10'
      },
      propJson: {
        title: '任务说明',
        message: '新用户首次完成运营商认证后，可领取金币奖励。',
        cacleBtn: '我知道了',
        showToast: false,
        isSecond: false,
      },
      btnText: '',
      customerId: '',
      list: ['5', '5', '抽奖', '10', '10', '10', '抽奖'],
      money: '',
      account: {},
      products: [],
      tasksCenter: [],
      receivableTasks: [],

    }
  },
  mounted () {
    this.customerId = this.$route.query.customerId;//
    this.util.title('签到领金币');
    this.getList();
  },
  methods: {
    //去抽奖
    toLuckDraw () {
      if (this.account.canLottery) {
        this.$router.push({
          path: '/vip/luckDraw',
        });
      }
    },
    changeBtnText (val) {
      let flag = this.account.flag;
      let continuousDay = this.account.continuousDay;
      let canLottery = this.account.canLottery;
      // if (continuousDay == 2 && canLottery) {
      //   return `已签到，前往抽奖`;
      // } else if (continuousDay >= 1 && flag) {
      //   if (canLottery) {
      //     return `已签到，前往抽奖`;
      //   } else {
      //     return `已连续签到 ${continuousDay} 天`;
      //   }
      // } else if (continuousDay == 2 && !canLottery || continuousDay == 6 && !canLottery) {
      //   return `签到抽奖`;
      // } else {
      //   return `签到领金币`;
      // }
      if (flag) {
        if (canLottery) {
          return `已签到，前往抽奖`;
        } else {
          return `已连续签到 ${continuousDay} 天`;
        }
      } else {
        if (continuousDay == 2 && !canLottery || continuousDay == 6 && !canLottery) {
          return `签到抽奖`;
        } else {
          return `签到领金币`;
        }
      }



    },
    changeStatus (status) {
      if (status == '0') {
        return '领取任务'
      } else {
        return '进行中'
      }
    },
    toHideGif () {
      this.coinsPropJson.isShow = false;
      this.$refs.vueLottie.anim.stop();
    },
    toShowGif (price, flag) {
      this.coinsPropJson.isShow = true;
      this.coinsPropJson.price = price;
      this.$refs.vueLottie.anim.play();
      this.$refs.vueLottie.failAudio.play()
      let _this = this;
      setTimeout(() => {
        _this.toHideGif();
      }, 2000)

    },
    async toSign () {
      if (!this.account.flag) {
        await this.checkIn();//去签到
        await this.getList();//去签到
        await this.toCheck();
      } else if (this.account.flag && this.account.canLottery) {
        //去抽奖
        this.$router.push({
          path: '/vip/luckDraw'
        });
      }
    },
    async toCheck () {
      let price = this.list[this.account.continuousDay - 1];
      if (this.account.canLottery) {
        //去抽奖
        this.$router.push({
          path: '/vip/luckDraw'
        });
      } else {
        this.toShowGif(price, this.account.flag)
      }
    },
    showCoins (item) {
      this.getCoins(item);//领取金币
      this.toShowGif(item.price)
    },
    showTaskToast (item, isBtn) {
      if (isBtn == 1 && item.status == '0') {
        //调用领取任务接口
        this.getTaskPost(item);
      }
      if (!item.continuous) {//单次任务
        this.propJson.tag = '单次任务';
      } else {
        this.propJson.tag = '';
      }
      this.propJson.message = item.description;
      this.propJson.showToast = true;

    },
    getTaskPost (item) {
      let _this = this;
      this.$post('/app/valueAdded/receiveTask/' + item.id, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.getList();
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    getCoins (item) {
      let _this = this;
      this.$post('/app/valueAdded/receiveGold/' + item.id, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.getList();
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    getTask () {
      //掉接口
      this.propJson.showToast = true;
    },
    sureClick () {
      //调用接口立即兑换
      this.propJson = {
        message: '恭喜兑换成功！已放入我的卡券',
        cacleBtn: '稍后查看',
        sureBtn: '前往查看',
        showToast: true,
        isSecond: true,
      }
    },
    secondClick () {
      alert('前往查看跳转至我的卡券页面——原生')
    },
    //签到页面
    async checkIn () {
      let e = await this.$post('/app/valueAdded/checkin')
      if (e.code == 200) {
        this.account.continuousDay = e.data.continuousDay;
        console.log('111')
      }
      else {
        this.util.toast({ msg: e.message })
      }
    },
    async getList () {
      let e = await this.$get('/app/valueAdded/checkinPage')
      if (e.code == 200) {
        this.account = e.data.account;
        this.products = e.data.products;
        this.tasksCenter = e.data.tasksCenter;
        this.receivableTasks = e.data.receivableTasks;
        console.log("222")
      }
      else {
        this.util.toast({ msg: e.message })
      }
    },
    toPage (path, item) {
      if (item) {
        // 进入监测页面
        this.$router.push({
          path: path,
          query: {
            id: item.id
          }
        });
      } else {
        // 进入监测页面
        this.$router.push({
          path: path,
          query: {
          }
        });
      }

    },

  }

}
</script>
<style scoped>
.record_box {
  font-family: PingFangSC-Regular;
  background: #fff;
}
.header {
  display: inline-block;
  width: 100%;
  background: url("../../assets/img/vipActive/coins_bg.png") no-repeat center
    center;
  background-size: 100% 100%;
  height: 1.9rem;
}
.sign_icon,
.sign_icon3,
.sign_icon2,
.sign_icon4 {
  display: inline-block;
  width: 0.23rem;
  height: 0.23rem;
  background: url("../../assets/img/vipActive/sign_icon1.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.sign_icon4 {
  background: url("../../assets/img/vipActive/sign_icon4.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.sign_icon2 {
  background: url("../../assets/img/vipActive/sign_icon2.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.sign_icon3 {
  background: url("../../assets/img/vipActive/sign_icon3.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.h_title,
.h_coins {
  margin-top: 0.36rem;
  margin-left: 0.29rem;
  font-size: 0.17rem;
  font-family: PingFang;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.h_coins {
  font-size: 0.4rem;
  font-family: PingFang;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin-top: 0;
  position: relative;
  top: -0.1rem;
}
.sign_box {
  height: 2.1rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  margin: 0 0.15rem;
  padding: 0.2rem 0.14rem;
  position: relative;
  top: -0.73rem;
}
.sign_box .right {
  color: #999;
  font-size: 0.12rem;
  font-weight: normal;
}
.flx {
  display: flex;
  justify-content: space-between;
  flex: 1;
  margin-top: 0.22rem;
}
.flx li {
  width: 0.41rem;
  height: 0.62rem;
  margin-right: 0.04rem;
  border-radius: 4px;
  text-align: center;
  padding-top: 0.1rem;
  background: url("../../assets/img/vipActive/sign_bg.png") no-repeat center
    center;
  background-size: 100% 100%;
  font-size: 0.12rem;
  color: #666;
}
.flx li.active {
  background: url("../../assets/img/vipActive/sign_bgAct.png") no-repeat center
    center;
  background-size: 100% 100%;
  font-size: 0.12rem;
  color: #fff;
}
.icon_right {
  background: url("../../assets/img/vipActive/right_icon.png") no-repeat center
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.1rem;
  height: 0.1rem;
}
.s_title {
  font-size: 0.17rem;
  font-family: PingFangSC;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 0.17rem;
}
.s_btn {
  font-size: 0.17rem;
  font-family: PingFangSC;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
  width: 3.05rem;
  height: 0.5rem;
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 25px;
  margin: 0 auto;
  margin-top: 0.17rem;
}
.btn_Act {
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 25px;
  color: #ff6d37;
  background: rgba(255, 191, 128, 0.2);
}
.wait_box {
  background: #fff;
  position: relative;
  top: -0.2rem;
}
.record_item {
  background: #fff;
  padding: 0.2rem 0.15rem;
}
.look_limit {
  /* line-height: 0.37rem; */
  display: flex;
  height: 0.37rem;
  margin-bottom: 0.18rem;
}
.task_box .look_limit {
  height: 0.4rem;
}
.task_box .c_title {
  padding-top: 0.17rem;
}
.pd {
  color: #999;
  font-size: 0.12rem;
}
.name {
  font-size: 0.14rem;
  color: #333;
  font-family: PingFangSC;
  font-weight: 400;
  position: relative;
  top: 0.08rem;
}
.line {
  width: 100%;
  height: 0.1rem;
  background: #f7f7f7;
}
.task_box .name {
  top: 0;
}
.task_box .t_coins {
  color: #999;
  font-size: 0.14rem;
}
.logo {
  display: inline-block;
  width: 0.37rem;
  height: 0.37rem;
  margin-right: 0.08rem;
}
.limit {
  width: 0.7rem;
  height: 0.3rem;
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 15px;
  position: absolute;
  right: 0.15rem;
  color: #fff;
  font-size: 0.12rem;
  line-height: 0.3rem;
  text-align: center;
}

.bank_icon,
.people_icon,
.safety_icon,
.apply_icon,
.email_icon,
.phone_icon,
.task_icon {
  display: inline-block;
  width: 0.37rem;
  height: 0.37rem;
  /* background: url("../../assets/img/vipActive/bank_auth.png") no-repeat center
    center;
  background-size: 100% 100%; */
}
.people_icon {
  background: url("../../assets/img/vipActive/people_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.safety_icon {
  background: url("../../assets/img/vipActive/safety_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.apply_icon {
  background: url("../../assets/img/vipActive/apply_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.bank_icon {
  background: url("../../assets/img/vipActive/bank_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.email_icon {
  background: url("../../assets/img/vipActive/email_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.phone_icon {
  background: url("../../assets/img/vipActive/phone_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.task_icon {
  background: url("../../assets/img/vipActive/task_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.coins {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("../../assets/img/vip/luck/coins1.png") no-repeat center
    center;
  background-size: 100% 100%;
  position: relative;
  top: 0.03rem;
}
.c_title {
  font-size: 0.14rem;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  padding: 0 0.15rem;
}
.more {
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.c_title .icon_right {
  width: 0.12rem;
  height: 0.12rem;
  margin-left: 0.04rem;
  position: relative;
  top: 0.005rem;
}
.t_btnAct {
  background: rgba(255, 191, 128, 0.2);
  color: #ff4223;
  border: 1px solid #ff994d;
  color: rgba(255, 255, 255, 1);
  line-height: 12px;
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  height: 0.3rem;
  line-height: 0.3rem;
}
.look_box {
  /* display: flex;
  flex: 1;
  justify-content: space-around; */
  text-align: center;
  clear: both;
  overflow: hidden;
}
.look_box .item {
  float: left;
  width: 33%;
}
.look_box img {
  width: 0.96rem;
  height: 0.56rem;
  margin-top: 0.2rem;
}
.l_name {
  color: #000;
  font-size: 0.14rem;
}
.red {
  color: #ff514a;
  font-size: 0.12rem;
}
.shadow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
}
.info {
  font-size: 0.24rem;
  font-family: PingFangSC;
  font-weight: 500;
  color: #ff6d37;
}
.fn2 {
  font-size: 0.2rem;
  position: relative;
  top: -0.02rem;
  left: -0.04rem;
}
</style>
